<template>
  <div class="main_">
    <div class="fixed" v-if="!isWx">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
          </div>
          <div style="text-align: center; font-size: 0.35rem">入口选择</div>
          <div style="width: 0.3rem"></div>
        </div>
      </div>
    </div>
    <div class="fixed_pad" v-if="!isWx"></div>
    <div class="list_main">
      <div>
        <div>
          <img
            src="@/assets/img/enterpriseAccessBG.jpg"
            alt=""
            style="width: 100%"
          />
        </div>
        <div class="">
          <ul class="infoList">
            <li>
              <span class="key">APP在线报名及结果查询</span>
              <span class="mark" @click="newNotice"></span>
            </li>
            <li>
              <span class="key">报名、摇号、选房信息查询</span>
              <span class="mark" @click="changeNotice"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";

export default {
  name: "AnnouncePre",
  data() {
    return {
      isApp: this.$route.query.isApp || false,
      isWx: this.$route.query.isWx || false,
      wxAppToken:this.$route.query.user || false,
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    if (this.isApp) {
      window.sessionStorage.setItem("isApp", true);
    }
    if (this.isWx) {
      window.sessionStorage.setItem("isWx", true);
    }
    if(this.wxAppToken){
      window.sessionStorage.setItem("wxAppToken", this.wxAppToken);
    }
  },
  methods: {
    goback() {
      if (this.isApp) {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.goback(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.goback.postMessage(null);
        }
        // window.webkit.messageHandlers.goback.postMessage(null);
      } else {
        this.$router.go(-1);
      }
    },
    newNotice() {
      if (this.isApp || this.isWx) {
        this.$router.push({
          path: "/signUpRecord",
          query: {
            isApp: true,
          },
        });
      } else {
        this.$router.push({
          path: "/signUpRecord",
        });
      }
    },
    changeNotice() {
      if (this.isApp || this.isWx) {
        this.$router.push({
          path: "/personLottery",
          query: {
            isApp: true,
          },
        });
      } else {
        this.$router.push({
          path: "/personLottery",
        });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "AnnounceDetail" || to.name === "OneHouseOnePrice") {
      this.$store.dispatch("saveView", ["AnnouncePre"]).then(() => {
        next();
      });
    } else {
      this.$store.dispatch("saveView", []).then(() => {
        next();
      });
    }
  },
};
</script>
<style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.fixed_pad_new {
  padding-top: 1.5rem;
}
.top_text {
  max-width: 50%;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.fixed_top {
  padding-top: 20px;
}
.top_header {
  height: 0.7rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
  &.top_sm {
    padding: 0.1rem;
  }

  .to_map {
    font-size: 0.28rem;
    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
.search_con,
.search_con_l {
  background-color: #f6f6f6;
  border: 1px solid #f0f0f0;
  border-radius: 0.7rem;
  height: 0.7rem;
  box-sizing: border-box;
  font-size: 0.26rem;
  padding: 0 0.3rem;
  color: #303030;
  i {
    font-size: 0.36rem;
    margin-right: 0.2rem;
  }
}
input {
  width: 80%;
  height: 0.7rem;
  background-color: transparent;
}
.search_con {
  width: 90%;
  margin-left: 5%;
}

.list_main {
  background-color: #fff;
}
.infoList {
  padding-top: 0.2rem;
  padding-left: 0.2rem;
  li {
    font-size: 0.3rem;
    height: 1rem;
    border-bottom: 1px solid #efefef;
    position: relative;
    padding-right: 0.5rem;
    color: #606060;
    padding-left: 0.5rem;
    .key {
      line-height: 1rem;
    }
    .mark {
      position: absolute;
      left: 0;
      top: 0;
      right: 0.5rem;
      height: 100%;
      &:after {
        font-family: "iconfont" !important;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -webkit-text-stroke-width: 0.2px;
        -moz-osx-font-smoothing: grayscale;
        content: ">";
        position: absolute;
        right: 0;
        color: #606060;
        top: 0;
        line-height: 1rem;
        font-size: 0.4rem;
      }
    }
  }
}
</style>